document.addEventListener( 'DOMContentLoaded', function () {
  if(document.querySelectorAll('.section-nf-category-slider')) {
    document.querySelectorAll('.section-nf-category-slider').forEach( slideWrapper => {
      let paginationClass = slideWrapper.querySelector('.splide__pagination')?.dataset.class
      let sldeContainerId = slideWrapper.querySelector('.splide')?.getAttribute('id')
      let sldeContainer = slideWrapper.querySelector('.splide')
      let enableDesktopSlider = false;
      let enableMobileSlider = !sldeContainer.dataset.enableMobileSlider;
      let desktopPerPage = parseInt(sldeContainer.dataset.desktopPerPage);
      let mobilePerPage = parseInt(sldeContainer.dataset.mobilePerPage);
      let desktopColumnGap = parseInt(sldeContainer.dataset.desktopColumnGap);
      let mobileColumnGap = parseInt(sldeContainer.dataset.mobileColumnGap);
      if(sldeContainer.dataset.enableDesktopSlider != "true")
        enableDesktopSlider = true;
      if(sldeContainer.dataset.enableMobileSlider != "true")
        enableMobileSlider = true;
      let settingData = {
        type: 'slide',
        gap: desktopColumnGap,
        perPage: desktopPerPage,
        destroy: enableDesktopSlider,
        perMove: 1,
        updateOnMove: false,
        pagination: true,
        breakpoints: {
          749: {
            classes: {
              arrows: 'splide__arrows',
              prev  : 'splide__arrow--prev splide__arrow--prev',
              next  : 'splide__arrow--next splide__arrow--next'
            },
            type: "loop",
            arrows: false,
            pagination: true,
            perPage: mobilePerPage,
            perMove: 1,
            destroy: enableMobileSlider,
            gap: mobileColumnGap
          }
        }
      }
      settingData.type = 'slide'
      let nfCategorySlider = new Splide(`#${sldeContainerId}`, settingData).mount();

    })
  }
});
